module.exports = __webpack_public_path__ + "static/media/cheryl-cole.d8e75f4a.jpg";